<!-- 特典を探す 絞り込み -->
<template>
  <div class="crly-m-common-search-keyword-condition">
    <CrlyMoleculesCommonAccordion
      @clickToggle="clickToggle"
      :genreHeight="genreHeight"
    >
      <template v-slot:toggle>
        <div
          class="crly-m-common-search-keyword-condition__toggle"
          :class="{ open: isOpen }"
        >
          <span>{{ $t("search.keyword.condition") }}</span>
        </div>
      </template>
      <template v-slot:contents>
        <div
          class="crly-m-common-search-keyword-condition__contents"
          ref="searchElement"
        >
          <!-- トラベル選択時に表示する中カテゴリ分類 -->
          <CrlyMoleculesCommonSearchKeywordMiddleCategory
            v-show="activeCategory === CONST.CATEGORY_TYPE.TRAVEL"
            @changeActiveMiddleCategory="changeActiveMiddleCategory"
          />
          <!-- カテゴリ -->
          <CrlyAtomsCommonSearchKeywordPulldown
            v-show="activeCategoryCategory()"
            :list="categoryList"
            kinds="category"
            @changePulldown="changePulldownCategory"
          />
          <!-- 都道府県 -->
          <CrlyAtomsCommonSearchKeywordPulldown
            v-show="activeCategoryPrefecture()"
            :list="locationList"
            kinds="prefecture"
            @changePulldown="changePulldownLocation"
          />
          <!-- ジャンル -->
          <CrlyAtomsCommonSearchKeywordPulldownSelect
            v-show="activeCategoryGourmet()"
            :list="genreList"
            @changePulldown="changePulldownGenre"
          />
          <!-- 検索するジャンルを表示 -->
          <div
            v-if="activeCategory == 2"
            class="crly-m-common-search-keyword-condition__contents__item"
            ref="genreElement"
          >
            <!-- ジャンル名クリックで検索対象から削除 -->
            <div
              v-for="(value, index) in showSelectGenres"
              :key="index"
              class="crly-m-common-search-keyword-condition__contents__item__genre crly-icon"
              v-on:click="($event) => clickDelete(value)"
            >
              <span>{{ value.name }} </span>
            </div>
          </div>
          <!-- 市区町村 -->
          <CrlyAtomsCommonSearchKeywordPulldown
            v-show="activeCategoryMunicipalities()"
            :list="areaList"
            @changePulldown="changePulldownMunicipalities"
          />
          <!-- DP中カテゴリ -->
          <CrlyAtomsCommonSearchKeywordPulldown
            v-show="activeCategoryDP()"
            :list="dpMiddleCategoryList"
            @changePulldown="changeDPMiddleCategory"
          />
          <!-- DP小カテゴリ -->
          <CrlyAtomsCommonSearchKeywordPulldown
            v-show="activeCategoryDP()"
            :list="dpSmallCategoryList"
            @changePulldown="changeDPSmallCategory"
          />
          <!-- 物販中カテゴリ -->
          <CrlyAtomsCommonSearchKeywordPulldown
            v-show="activeCategoryShop()"
            :list="shopMiddleCategoryList"
            @changePulldown="changeShopMiddleCategory"
          />
          <!-- 物販小カテゴリ -->
          <CrlyAtomsCommonSearchKeywordPulldown
            v-show="activeCategoryShop()"
            :list="shopSmallCategoryList"
            @changePulldown="changeShopSmallCategory"
          />
        </div>
      </template>
    </CrlyMoleculesCommonAccordion>
  </div>
</template>

<script>
import CategoryList from "@crly/assets/data/categoryList";
import LocationList from "@crly/assets/data/locationList.js";
import ShopCategoryList from "@crly/assets/data/categoryListShop.js";

import CrlyAtomsCommonSearchKeywordPulldown from "@crly/components/atoms/common/search/keyword/Pulldown.vue";
import CrlyMoleculesCommonAccordion from "@crly/components/molecules/common/Accordion.vue";
import CrlyAtomsCommonSearchKeywordPulldownSelect from "@crly/components/atoms/common/search/keyword/PulldownSelect.vue";
import CrlyMoleculesCommonSearchKeywordMiddleCategory from "@crly/components/molecules/common/search/keyword/MiddleCategory.vue";

export default {
  name: "CrlyMoleculesCommonSearchKeywordCondition",
  components: {
    CrlyAtomsCommonSearchKeywordPulldown,
    CrlyMoleculesCommonAccordion,
    CrlyAtomsCommonSearchKeywordPulldownSelect,
    CrlyMoleculesCommonSearchKeywordMiddleCategory
  },
  props: {
    /**
     * 選択中の特大カテゴリ
     */
    activeCategory: {
      type: Number,
      default: null
    }
  },
  data() {
    return {
      isOpen: false,
      /**
       * ジャンル選択（検索用）
       */
      selectGenres: [],
      /**
       * ジャンル選択（表示用）
       */
      showSelectGenres: [],
      /**
       * 自動調整用のジャンル選択の高さ
       */
      genreHeight: 0,
      /**
       * 都道府県選択
       */
      selectArea: null,
      /**
       * DP中カテゴリ選択
       */
      selectDPMiddleCategory: null,
      /**
       * 中カテゴリ選択
       */
      selectShopMiddleCategory: null,
      /**
       * 選択中の中カテゴリ分類
       */
      activeMidCat: 1
    };
  },
  computed: {
    /**
     * カテゴリの一覧を生成する
     */
    categoryList() {
      const category = CategoryList.getCategoryTypeList(this.activeCategory),
        len = category.length;
      let res = [
        { name: this.$t("search.keyword.categoryDefault"), value: "" }
      ];

      for (let i = 0; i < len; i++) {
        const item = category[i],
          data = {
            name: item.catLrgNm,
            value: item.catLrgCd,
            catLrgCd: item.catLrgCd,
            catMidCd: item.catMidCd ? item.catMidCd : ""
          };
        res.push(data);
        res[item.catLrgNm] = data;
      }
      return res;
    },
    /**
     * エリアの一覧を生成する
     */
    locationList() {
      const len = LocationList.LOCATION.length;
      let res = [
        { name: this.$t("search.keyword.locationDefault"), value: "" }
      ];

      for (let i = 0; i < len; i++) {
        const item = LocationList.LOCATION[i];
        let group = [];

        const childrenLen = item.list.length;
        for (let j = 0; j < childrenLen; j++) {
          const location = item.list[j];
          group.push({
            name: location.name,
            value: location.areaMidCd,
            number: location.num
          });
        }
        res.push({
          name: item.name,
          optgroup: true,
          list: group
        });
      }
      return res;
    },
    /**
     * ジャンルの一覧を生成する
     */
    genreList() {
      const genre = CategoryList.CATEGORY.find(
        (el) => el.catLrgCd === "113"
      ).list.find((el) => el.catMidCd === "201").list;
      const len = genre.length;
      let res = [{ name: this.$t("search.keyword.genreDefault"), value: "" }];

      for (let i = 0; i < len; i++) {
        const item = genre[i];
        res.push({
          name: item.catSmNm,
          value: item.catSmlCd
        });
      }
      return res;
    },
    /**
     * 市区町村の一覧を生成する
     */
    areaList() {
      let res = [{ name: this.$t("search.keyword.areaDefault"), value: "" }];

      if (this.selectArea !== null) {
        const len = this.selectArea.length;

        for (let i = 0; i < len; i++) {
          const item = this.selectArea[i];
          res.push({
            name: item.areaSmlClassNm,
            value: item.areaSmlClassCd
          });
        }
      }
      return res;
    },
    /**
     * DP中カテゴリの一覧を生成する
     */
    dpMiddleCategoryList() {
      const res = [{ name: this.$t("search.keyword.category"), value: "" }];
      const category = CategoryList.getAll();
      const categoryTravel = category.find((el) => el.catLrgCd === "101");
      for (const el of categoryTravel.list) {
        if (el.catType) {
          res.push({
            name: el.catMidNm,
            value: el.catMidCd
          });
        }
      }
      return res;
    },
    /**
     * DP小カテゴリの一覧を生成する
     */
    dpSmallCategoryList() {
      const res = [
        { name: this.$t("search.keyword.smallCategory"), value: "" }
      ];
      if (this.selectDPMiddleCategory !== null) {
        for (const el of this.selectDPMiddleCategory) {
          res.push({
            name: el.catSmNm,
            value: el.catSmlCd
          });
        }
      }
      return res;
    },
    /**
     * 中カテゴリの一覧を生成する
     */
    shopMiddleCategoryList() {
      const res = [{ name: this.$t("search.keyword.category"), value: "" }];
      const category = ShopCategoryList.getAll();
      for (const el of category[0].list) {
        res.push({
          name: el.catMidNm,
          value: el.catMidCd
        });
      }
      return res;
    },
    /**
     * 小カテゴリの一覧を生成する
     */
    shopSmallCategoryList() {
      const res = [
        { name: this.$t("search.keyword.smallCategory"), value: "" }
      ];
      if (this.selectShopMiddleCategory !== null) {
        for (const el of this.selectShopMiddleCategory) {
          res.push({
            name: el.catSmNm,
            value: el.catSmlCd
          });
        }
      }
      return res;
    }
  },
  methods: {
    /**
     * トグルのクリックイベント
     */
    clickToggle(status = !this.isOpen) {
      this.isOpen = status;
    },
    /**
     * 中カテゴリ分類変更イベント
     */
    changeActiveMiddleCategory(activeMiddleCategory) {
      this.activeMidCat = activeMiddleCategory;
      this.$emit("activeMidCat", this.activeMidCat);
      this.getGenreElementHeight();
    },
    /**
     * カテゴリ選択イベント
     */
    changePulldownCategory(catCd) {
      this.$emit("catLrgCd", catCd);
    },
    /**
     * 場所選択イベント
     */
    async changePulldownLocation(areaCd) {
      if (areaCd) {
        const res = await this.$repositories("search").getCodesArea({
          areaLrgClassCd: "region-" + areaCd.number,
          areaMidClassCd: areaCd.value
        });
        this.selectArea =
          res.data.areaLrgClasses[0].areaMidClasses[0].areaSmlClasses;
      } else {
        this.selectArea = null;
      }
      this.$emit("areaLrgCd", `region-${areaCd.number}`);
      this.$emit("areaMidCd", areaCd.value);
    },
    /**
     * ジャンル選択イベント
     */
    changePulldownGenre(genreCd) {
      const genreCheck = this.selectGenres.find(
        (element) => element === genreCd.value
      );
      /**
       * ジャンル選択に同じジャンルコードが存在しているかつ
       * 選択したジャンルにジャンルコードが存在しない場合
       */
      if (genreCd.value && genreCheck !== genreCd.value) {
        this.selectGenres.push(genreCd.value);
        this.showSelectGenres.push(genreCd);
      }
      this.$emit("lifeGenreTags", this.selectGenres);
      this.getGenreElementHeight();
    },
    /**
     * 市区町村変更イベント
     */
    changePulldownMunicipalities(areaMiddleCd) {
      this.$emit("areaSmlCd", areaMiddleCd);
    },
    /** DP中カテゴリ変更イベント
     * @param {String} catMidCd カテゴリコード
     */
    changeDPMiddleCategory(catMidCd) {
      const category = CategoryList.getAll();
      const categoryTravel = category.find((el) => el.catLrgCd === "101");
      const middleCategory = categoryTravel?.list.find(
        (el) => el.catMidCd === catMidCd && el.catType
      );
      this.$emit("catMidCdDP", catMidCd, middleCategory?.catType);
      this.selectDPMiddleCategory = middleCategory?.list;
    },
    /**
     * DP小カテゴリ変更イベント
     * @param {String} catSmlCd カテゴリコード
     */
    changeDPSmallCategory(catSmlCd) {
      this.$emit("catSmlCdDP", catSmlCd);
    },
    /**
     * ジャンル表示で高さをレスポンシブに設定
     */
    getGenreElementHeight() {
      this.$nextTick(() => {
        this.genreHeight = this.$refs.searchElement.offsetHeight;
      });
    },
    /**
     * 暮らす・遊ぶカテゴリ
     */
    activeCategoryCategory() {
      if (this.activeCategory === this.CONST.CATEGORY_TYPE.LIFE) {
        return true;
      }
      return false;
    },
    /**
     * 暮らす・遊ぶカテゴリ、食べるカテゴリ、、トラベル国内宿泊カテゴリ
     */
    activeCategoryPrefecture() {
      if (
        this.activeCategory === this.CONST.CATEGORY_TYPE.LIFE ||
        this.activeCategory === this.CONST.CATEGORY_TYPE.GOURMET ||
        (this.activeCategory === this.CONST.CATEGORY_TYPE.TRAVEL &&
          this.activeMidCat === this.CONST.TRAVEL_SEARCH_TYPE.STAY)
      ) {
        return true;
      }
      return false;
    },
    /**
     * 食べるカテゴリ
     */
    activeCategoryGourmet() {
      if (this.activeCategory === this.CONST.CATEGORY_TYPE.GOURMET) {
        return true;
      }
      return false;
    },
    /**
     * トラベル国内宿泊カテゴリ
     */
    activeCategoryMunicipalities() {
      if (
        this.activeCategory === this.CONST.CATEGORY_TYPE.TRAVEL &&
        this.activeMidCat === this.CONST.TRAVEL_SEARCH_TYPE.STAY
      ) {
        return true;
      }
      return false;
    },
    /**
     * トラベルDPカテゴリ
     */
    activeCategoryDP() {
      if (
        this.activeCategory === this.CONST.CATEGORY_TYPE.TRAVEL &&
        this.activeMidCat === this.CONST.TRAVEL_SEARCH_TYPE.DP
      ) {
        return true;
      }
      return false;
    },
    /**
     * 選択ジャンル削除処理
     */
    clickDelete(genre) {
      // 削除前の選択ジャンルコード
      const newSelectGenres = this.showSelectGenres.filter((element) => {
        return element !== genre;
      });
      this.showSelectGenres = newSelectGenres;
      this.selectGenres = newSelectGenres.map((element) => {
        return element.value;
      });
      this.$emit("lifeGenreTags", this.selectGenres);
      this.getGenreElementHeight();
    },
    /**
     * 中カテゴリ変更イベント
     * @param {String} catMidCd カテゴリコード
     */
    changeShopMiddleCategory(catMidCd) {
      this.$emit("catMidCdShop", catMidCd);
      // 連動する小カテゴリの値をリセット
      this.$emit("catSmlCdShop", "");
      const category = ShopCategoryList.getAll();
      const middleCategory = category[0].list.find(
        (el) => el.catMidCd === catMidCd
      );
      this.selectShopMiddleCategory = middleCategory.list;
    },
    /**
     * 物販小カテゴリ変更イベント
     * @param {String} catSmlCd カテゴリコード
     */
    changeShopSmallCategory(catSmlCd) {
      this.$emit("catSmlCdShop", catSmlCd);
    },
    /**
     * ベネ通販カテゴリ
     */
    activeCategoryShop() {
      if (this.activeCategory === this.CONST.CATEGORY_TYPE.BENE) {
        return true;
      }
      return false;
    }
  },
  watch: {
    activeCategory() {
      this.$nextTick(() => {
        this.genreHeight = this.$refs.searchElement.offsetHeight;
      });
    }
  }
};
</script>

<style lang="scss" scoped>
@import "@crly/assets/css/molecules/common/search/keyword/condition.scss";
</style>
